import { takeEvery, call, put, select } from 'redux-saga/effects';
import { t } from 'utils/translates';
import {
  sendRequest,
  requestFinished,
  setErrors,
  clearAllErrors,
  selectFieldAvatarFile,
  deleteAvatar
} from '../../../../common/reducers/forms/avatarForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserProfileService from '../../../../services/UserProfileService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../common/reducers/states/authAccount';

function* uploadPhoto(reducerName) {
  const fieldFiles = yield select(selectFieldAvatarFile, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const result = yield call(
      timeoutCall,
      UserProfileService.photoUpload,
      fieldFiles.value
    );
    if (result.response) {
      if (result.response.status === 422) {
        yield put(setErrors(reducerName, result.response.data));
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'danger',
            message: result.response.data[0].message
          })
        );
      } else if (result.response.status === 200) {
        yield put(sendGetAuthAccountDataRequest());
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: t('Фото успешно изменено')
          })
        );
      }
    }
    yield put(
      requestFinished(
        reducerName,
        result.response.status,
        result.response.status === 200
      )
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

function* removePhoto(reducerName) {
  try {
    yield put(clearAllErrors(reducerName));

    const result = yield call(timeoutCall, UserProfileService.photoRemove);
    if (result.response) {
      if (result.response.status === 200) {
        yield put(sendGetAuthAccountDataRequest());
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: t('Фото успешно удалено')
          })
        );
      }
    }
    yield put(
      requestFinished(
        reducerName,
        result.response.status,
        result.response.status === 200
      )
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, uploadPhoto, reducerName),
    takeEvery(deleteAvatar(reducerName).type, removePhoto, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/avatarFormSaga.js